import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import Slick from 'react-slick'
import { trackPromotionClick } from 'helpers'

export class FeaturedContent extends React.PureComponent<FeaturedContent.Props, FeaturedContent.State> {
  public static sectionId = 'content';
  private sliderRef;
  public constructor(props) {
    super(props)
    this.sliderRef = React.createRef()
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }

  next() {
    this.sliderRef.slickNext()
  }
  previous() {
    this.sliderRef.slickPrev()
  }

  public buildItem(block: FeaturedContent.Block, i: number, settings: any) {
    const { article } = this.props.data.section

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = article?.settings?.allow_full_width_images
    const reverse = !block.settings.reverse || block.settings.reverse === 'false' ? false : true

    const headingstyle = settings?.headingstyle?.toLowerCase()

    return (
      <div className={`w-full sm:mb-6-4 mb-3-2 sm:w-1/3 sm:px-1-2 ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`} key={i}>
        {block.settings.imageurl
          ? <Snippets.Link
            onClick={() => trackPromotionClick(
              [{
                id: `${this.props.section.id}-block-${i}`,
                name: block.settings.title,
                position: `${i}`,
                creative: 'Feature content'
              }],
              block.settings.linkurl
            )}
            title={block.settings.title}
            className={'block w-full relative mb-3-2'}
          >
            <Snippets.Image
              alt={block.settings.title || 'Featured content image'}
              className={'bg-cover bg-center absolute inset-0 h-full'}
              ratio={settings?.tallimageratio ? '2:3' : '1:1'}
              src={block.settings.image}
            />
          </Snippets.Link>
          : <div className={'w-full relative mb-3-2'}>
            <Snippets.Image
              alt={block.settings.title || 'Featured content image'}
              className={'bg-cover bg-center absolute inset-0 h-full'}
              ratio={settings?.tallimageratio ? '2:3' : '1:1'}
              src={block.settings.image}
            />
          </div>}
        <div className={'w-full'}>
          <Snippets.Heading
            tag={headingstyle == 'serif' ? 'h2' : 'h5'}
            className={` text-${settings?.contentalignmentHorizontalMobile} md:text-${settings?.contentalignmentHorizontal}  ${headingstyle == 'serif' ? 'font-mono mb-2 border-t border-black pt-2' : 'font-bold tracking-wide mb-0-8'}`}
          >
            {block.settings.title}
          </Snippets.Heading>
          {block.settings.content ? (
            <Snippets.RichText className={`rte leading-base text-${settings?.contentalignmentHorizontalMobile} md:text-${settings?.contentalignmentHorizontal} ${block.settings.useCustomColor ? `text-[${block.settings.contentColor}]` : ''}`}>
              {block.settings.content}
            </Snippets.RichText>
          ) : null}
          {block.settings.linktext ? (
            <div className={`w-full text-${settings?.CTAalignmentHorizontalMobile} md:text-${settings?.CTAalignmentHorizontal}` }>
              <Snippets.Button
                onClick={() => trackPromotionClick(
                  [{
                    id: `${this.props.section.id}-block-${i}`,
                    name: block.settings.title,
                    creative: 'Feature content',
                    position: `${i}`
                  }],
                  block.settings.linkurl
                )}
                colour={'secondary'}
                className={'mt-2 w-4/5'}
                title={block.settings.linktext}
              >
                {block.settings.linktext}
              </Snippets.Button>
            </div>
          ) : null}

        </div>
      </div>
    )
  }

  public buildCarousel(blocks: FeaturedContent.Blocks) {
    const { settings } = this.props.section
    
    const sliderSettings = {
      centerPadding: '20px',
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerPadding: '12px',
            infinite: false,
            centerMode: true,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerPadding: '24px',
            infinite: true,

          }
        },
      ]
    }
    return (
      <div className='slider-container'>
        <div className={`flex items-center py-2 ${settings.heading && settings.headingAlignment === 'center' ? 'justify-end' : 'justify-between'}`}>
          {settings.heading && settings.headingAlignment === 'left' && (
            <Snippets.Heading
              tag={'h5'}
              className={'hidden md:block font-bold tracking-wide text-left pl-2'}
            >
              {settings.heading}
            </Snippets.Heading>
          )}
          <div className='flex items-center justify-between md:justify-end'>
            <button className="button px-1-2" onClick={this.previous}>
              <Snippets.Icon name={'arrow_left'} width={18} label={'next slide'} />
            </button>
            <button className="button px-1-2" onClick={this.next}>
              <Snippets.Icon name={'arrow_right'} width={18} label={'previous slide'} />
            </button>
          </div>
        </div>
        <Slick {...sliderSettings} ref={c => (this.sliderRef = c)}>
          {blocks.map((item:FeaturedContent.Block, idx) => (
            <div key={idx} className='item-container pr-2 md:px-2'>
              <div className='border-b pb-2-4 border-black'>
                <Snippets.Image
                  alt={item.settings.title || 'featured image content'}
                  ratio={'5:6'}
                  className={''}
                  src={item.settings.image}
                />
              </div>
                  
              <Snippets.Heading tag='h2' className='text-2xl 
           font-light 
           font-mono leading-none font-mono py-2'>
                {item.settings.title}
              </Snippets.Heading>
                
              <Snippets.RichText className={'rte leading-base'}>
                {item.settings.content}
              </Snippets.RichText>
            </div>
          ))}
        </Slick>
      </div>
    )

  }



  public render(): JSX.Element {
    const { settings, blocks } = this.props.section

    let windowWidth = window?.innerWidth
    if (!settings) {
      return <React.Fragment />
    }

    const carousel = () => {

      if (settings.iscarousel) {
        return (
          this.buildCarousel(blocks)
        )
      }
      const standardView = (className = 'flex') => {
        return (
          <>
            <div className={`${className} sm:flex-row flex-col sm:flex-nowrap flex-wrap sm:-mx-1-2`}>
              {blocks ? (
                blocks.map((block: any, i: number) => this.buildItem(block, i, settings))
              ) : []
              }
            </div>
          </>
        )
      }
      if (!settings.iscarousel && settings?.carouseltoggle === 'Desktop Only') {
        return  (
          <>
            <div className="hidden sm:block">
              {this.buildCarousel(blocks)}
            </div>
            {standardView('flex sm:hidden')}
          </>
        )
      }
      if (!settings.iscarousel && settings?.carouseltoggle === 'Mobile Only') {
        return  (<>
          <div className="block sm:hidden">
            {this.buildCarousel(blocks)}
          </div>
          {standardView('hidden sm:flex')}
        </>
        )
      }             

      return standardView()    
      
    }

    return (
      <section className={`dynamic-featured-content ${settings.backgroundColor ? ' bg-core-pale' : ''} sm:py-6-4 py-3-2`}>
        <div className={`${settings.fullwidth ? 'px-2-4' : 'max-w-8xl sm:px-2-4 2xl:px-22 xl:px-2-8'} px-1-6 mx-auto`}>
          {settings.heading && (
            <Snippets.Heading
              tag={'h5'}
              className={`font-bold tracking-wide mb-4 ${settings.headingAlignment === 'center' ? ' text-center' : 'text-left md:hidden'}`}
            >
              {settings.heading}
            </Snippets.Heading>
          )}

          {carousel()}
        </div>
      </section>
    )
  }
}

export namespace FeaturedContent {
  export type Options = ShopifyNext.Section<{
    title: any;
    heading: string;
    headingAlignment: string;
    fullwidth: boolean;
    bgcolour: string;
    imgwidth: string;
    alignment: string;
    colour: string;
    marginb: boolean;
    arrows: boolean;
    iscarousel: boolean;
    carouseltoggle: string;
    backgroundColor?: boolean;
  }>;
  export type Block = {
    settings: {
      fullwidth?: boolean;
      heading?: string;
      headingstyle?: string;
      contentalignment?: string;
      contentalignmentMobile?: string;
      CTAalignmentHorizontal?: string;
      CTAalignmentHorizontalMobile?: string;
      tallimageratio?: boolean;
      reverse: string;
      title: string;
      image: string;
      imageurl: string;
      content: string;
      linktext: string;
      linkurl: string;
      useCustomColor: boolean;
      contentColor: string;
    }
  }
  export type Blocks = Block[]
  export interface Props extends GlobalProps {
    section: FeaturedContent.Options;
    blocks: FeaturedContent.Blocks;
  }
  export interface State { }
}
